/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';

import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';

import { Link } from 'react-router-dom';
import { object } from 'prop-types';

const styles = {
    bannerOuterGrid: {
        width: '100%',
        '& img': {
            width: 'inherit',
            display: 'block',
        },
        '& a': {
            '& img': {
                width: '100%',
            },
        },
    },
};
const GraphqlSideRailBanner = ({ classes, bannerData = {}  }) => {
    if (bannerData && bannerData !== null) {
        const href = bannerData?.link?.href || null;
        const url = bannerData?.image?.url || null;
        if (href && url) {
            if ((href.indexOf('http://') === 0 || href.indexOf('https://') === 0)) {
                return (
                    <Grid className={classes.bannerOuterGrid}>
                        <a href={href} id={bannerData?.link?.title}>
                            <img src={url} alt={bannerData?.image?.title} />
                        </a>
                    </Grid>
                );
            }
            return (
                <Grid className={classes.bannerOuterGrid}>
                    <Link to={href} id={bannerData?.link?.title}>
                        <img src={url} alt={bannerData?.image?.title} />
                    </Link>
                </Grid>
            );
        }
        return (
            url &&  (
                <Grid className={classes.bannerOuterGrid}>
                    <img src={url} alt={bannerData?.image?.title} />
                </Grid>
            )
        );
    }
    return null;
};

GraphqlSideRailBanner.propTypes = {
    bannerData: object.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(GraphqlSideRailBanner);
